import { render, staticRenderFns } from "./FlexibleSpaceA.vue?vue&type=template&id=f2de014a&scoped=true"
import script from "./FlexibleSpaceA.vue?vue&type=script&lang=js"
export * from "./FlexibleSpaceA.vue?vue&type=script&lang=js"
import style0 from "./FlexibleSpaceA.vue?vue&type=style&index=0&id=f2de014a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2de014a",
  null
  
)

export default component.exports